import React from 'react';
import { OverlayTrigger, Tooltip, Overlay, Popover, Clearfix } from 'react-bootstrap';

import Autocomplete from 'components/forms/Autocomplete';

import IntlFormIndicator from 'components/intlForm/IntlFormIndicator';
import IntlFormSelector from 'components/intlForm/IntlFormSelector';

export default class FormLangAutocomplete extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      initialValue: props.value || '',
      focused: false,
      showIntlSelector: false,
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { focused } = this.state;

    if (prevState.focused && !focused) {
      this.timeout = setTimeout(() => this.setState({ showIntlSelector: false }), 300);
    }
  };

  componentWillUnmount = () => {
    clearTimeout(this.timeout);
  };

  checkFocused = () => {
    return this.state.focused ? 'focused ' : '';
  };

  checkRequired = () => {
    return this.props.meta.validate.rules.indexOf('required') !== -1 ? 'required ' : '';
  };

  checkError = () => {
    return this.props.validation.valid ? '' : 'has-error ';
  };

  // check if user may read this field
  checkAccess = () => {
    return this.props.meta.acl.read;
  };

  // check if user may write to this field
  checkReadOnly = () => {
    return !this.props.meta.acl.write;
  };

  catchFocus = () => {
    this.input.focus();
  };

  onChange = option => {
    const { name, onChange, returnValueObject } = this.props;

    if (returnValueObject) {
      onChange(name, option);
    } else {
      // onChange(name, option.value)
    }

    /* let newValue = [], isNewValue = true;
    _.forEach(this.state.value, (langValue, index) => {
      if (langValue.lang == appIntl.displayIntlForm) {
        newValue.push({ ...langValue, name: value })
        isNewValue = false;
      } else {
        newValue.push({ ...langValue})
      }
    })
    if (isNewValue) {
      newValue.push({ lang: appIntl.displayIntlForm, name: value })
    }

    this.setState({ value: newValue }) */
  };

  checkDisabled = () => {
    const { disabled, meta } = this.props;

    if (disabled) {
      return true;
    }
    if (!meta.acl.write) {
      return true;
    }
    return false;
  };

  setValue = value => {
    this.onChange(value);
  };

  render() {
    const {
      label,
      name,
      value,
      validation,
      disabled,
      autocompleteType,
      complete,
      options,
      placeholder,
      infoText,
      urlFilters,
    } = this.props;
    const { showIntlSelector } = this.state;

    return (
      <div
        class={
          'form-group multi-lang form-group-default ' +
          this.checkFocused() +
          this.checkRequired() +
          this.checkError() +
          (this.checkDisabled() ? 'disabled ' : '')
        }
        onClick={this.catchFocus}
        style={{ overflow: 'visible' }}
      >
        <Clearfix>
          <label class="pull-left">
            {label}
            <IntlFormIndicator show={!showIntlSelector} />
            {infoText ? (
              <span class="m-l-5">
                <OverlayTrigger placement="top" overlay={<Tooltip>{infoText}</Tooltip>}>
                  <i class="far fa-question-circle cursor-help" />
                </OverlayTrigger>
              </span>
            ) : null}
          </label>
          <div class="pull-left m-l-10">{showIntlSelector ? <IntlFormSelector /> : null}</div>
        </Clearfix>
        <Autocomplete
          inputRef={input => (this.input = input)}
          name={name}
          disabled={disabled}
          type={autocompleteType}
          urlFilters={urlFilters}
          value={value}
          onChange={this.onChange}
          complete={complete}
          options={options}
          placeholder={placeholder}
          onFocus={() => {
            clearTimeout(this.timeout);
            this.setState({ focused: true, showIntlSelector: true });
          }}
          onBlur={() => this.setState({ focused: false })}
        />

        <Overlay show={this.state.focused && !validation.valid} target={this.input} placement="top">
          <Popover id={name} class="popover-modal">{validation.helpText}</Popover>
        </Overlay>
      </div>
    );
  }
}
FormLangAutocomplete.defaultProps = {
  value: '',
  complete: false,
  label: '',
  meta: { validate: { rules: '' }, acl: { read: true, write: true } },
  validation: { valid: true },
  onChange: () => {},
  returnValueObject: true,
  disabled: false,
  infoText: '',
  urlFilters: {},
};
